import cx from 'classnames';

export const REACT_SELECT_DEFAULT_STYLES = {
  control: state =>
    cx(
      'tw-border tw-rounded-none tw-shadow-none',
      'tw-w-full tw-h-12 tw-focus:outline-none tw-transition',
      {
        'tw-border-focus-outline': state.isFocused,
        'tw-bg-gray-100': state.isDisabled
      }
    ),
  menu: _state => cx('tw-z-30 tw-mt-0 tw-rounded-none'),
  option: state =>
    cx('tw-text-gray-800 tw-cursor-pointer', {
      'tw-bg-gray-100 tw-text-gray-900': state.isFocused,
      'tw-bg-primary-100 tw-text-gray-900': state.isSelected,
      'tw-hover:bg-gray-100': !state.isSelected,
      'tw-bg-gray-200 tw-text-gray-400 tw-cursor-not-allowed': state.isDisabled
    }),
  indicatorsContainer: _state => cx('tw-h-12'),
  valueContainer: _state => cx('tw-h-12 tw-overflow-hidden'),
  singleValue: _state => cx('tw-overflow-visible')
};

export const REACT_SELECT_INLINE_STYLES = {
  control: state =>
    cx(
      'tw-border tw-rounded-none tw-shadow-none',
      'tw-w-full tw-h-6 tw-focus:outline-none tw-transition',
      {
        'tw-border-focus-outline': state.isFocused,
        'tw-bg-gray-100': state.isDisabled
      }
    ),
  menu: () => cx('tw-z-30 tw-mt-0 tw-rounded-none'),
  option: state =>
    cx('tw-text-gray-800 tw-cursor-pointer', {
      'tw-bg-gray-100 tw-text-gray-900': state.isFocused,
      'tw-bg-primary-100 tw-text-gray-900': state.isSelected,
      'tw-hover:tw-bg-gray-100': !state.isSelected,
      'tw-bg-gray-200 tw-text-gray-400 tw-cursor-not-allowed	': state.isDisabled
    }),
  clearIndicator: _state => cx('tw-pl-0 tw-pr-0.5'),
  valueContainer: _state => cx('tw-pl-1 tw-pr-0'),
  dropdownIndicator: _state => cx('tw-px-1')
};
